import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function UsersIcon({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}>
      <path fill="none" d="M0 0h24v24H0z" />
      <g fill={color}>
        <path d="M19.001 4h3v5h-3zM19.001 10h3v5h-3zM16.001 2h-12c-1.104 0-2 .895-2 2v16c0 1.104.896 2 2 2h12c1.104 0 2-.896 2-2V4c0-1.105-.896-2-2-2zm-6 5c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .895-2 2-2zm-3 8c0-1.841 1.159-3 3-3s3 1.159 3 3h-6z" />
      </g>
    </svg>
  );
}
